export default __webpack_public_path__ + "static/media/weather.6adff9f3.png";